export default {
    'single': {
        'combination': [
            {
                0: {
                    name: "MiniCard",
                    subtitle: "",
                    type: ["Melk", "Puur", "Wit"],
                    weight: ["10gr", "7gr"],
                    packaging: ["in CandyCard flowpack", "in transparante flowpack", "in gepersonaliseerde flowpack"],
                    amounts: [1800, 3000, 6000, 10200, 20400]
                },
                1: {
                    name: "Praline",
                    subtitle: "",
                    type: ["Melk", "Puur", "Wit"],
                    weight: ["15gr"],
                    packaging: ["in CandyCard flowpack", "in transparante flowpack", "in gepersonaliseerde flowpack", "in Goldblister Box"],
                    amounts: [1000, 2000, 3000, 5000, 10000, 20000]
                }
            }
        ]
    },
    'box-3': {
        'combination': [
            {
                0: {
                    name: "MiniCard",
                    subtitle: "6 Stuks (2 x 3)",
                    type: ["Melk", "Puur", "Wit", "Mix"],
                    weight: ["10gr"],
                    packaging: ["in een geschenkdoos", "in een geschenkdoos met gepersonaliseerde huls", "in een gepersonaliseerde geschenkdoos"],
                    amounts: [150, 270, 510, 1020, 2520]
                },
                1: {
                    name: "Praline",
                    subtitle: "3 Stuks",
                    type: ["Melk", "Puur", "Wit", "Mix"],
                    weight: ["15gr"],
                    packaging: ["in een geschenkdoos", "in een geschenkdoos met gepersonaliseerde huls", "in een gepersonaliseerde geschenkdoos"],
                    amounts: [150, 270, 510, 1020, 2520]
                }
            }
        ]
    },
    'box-6': {
        'combination': [
            {
                0: {
                    name: "MiniCard",
                    subtitle: "12 Stuks (2 x 6)",
                    type: ["Melk", "Puur", "Wit", "Mix"],
                    weight: ["10gr"],
                    packaging: ["in een geschenkdoos", "in een geschenkdoos met gepersonaliseerde huls", "in een gepersonaliseerde geschenkdoos"],
                    amounts: [80, 120, 240, 500, 1000, 2500]
                },
                1: {
                    name: "Praline",
                    subtitle: "6 Stuks",
                    type: ["Melk", "Puur", "Wit", "Mix"],
                    weight: ["15gr"],
                    packaging: ["in een geschenkdoos", "in een geschenkdoos met gepersonaliseerde huls", "in een gepersonaliseerde geschenkdoos"],
                    amounts: [120, 240, 500, 1000, 2500]
                }
            }
        ]
    },
    'maxi-card': {
        'combination': [
            {
                0: {
                    name: "Postcard",
                    subtitle: "",
                    type: ["Melk", "Puur", "Wit"],
                    weight: ["100gr"],
                    packaging: ["in een geschenkdoos", "in een geschenkdoos met gepersonaliseerde huls", "in een gepersonaliseerde geschenkdoos"],
                    amounts: [80, 120, 240, 500, 1000, 2500]
                },
                1: {
                    name: "ChristmasCard",
                    subtitle: "",
                    type: ["Wit"],
                    weight: ["100gr"],
                    packaging: ["in een geschenkdoos", "in een geschenkdoos met gepersonaliseerde huls", "in een gepersonaliseerde geschenkdoos"],
                    amounts: [80, 120, 240, 500, 1000, 2500]
                },
                2: {
                    name: "EasterCard",
                    subtitle: "",
                    type: ["Wit"],
                    weight: ["100gr"],
                    packaging: ["in een geschenkdoos", "in een geschenkdoos met gepersonaliseerde huls", "in een gepersonaliseerde geschenkdoos"],
                    amounts: [80, 120, 240, 500, 1000, 2500]
                },
                3: {
                    name: "MedaillionCard",
                    subtitle: "",
                    type: ["Wit"],
                    weight: ["100gr"],
                    packaging: ["in een geschenkdoos", "in een geschenkdoos met gepersonaliseerde huls", "in een gepersonaliseerde geschenkdoos"],
                    amounts: [80, 120, 240, 500, 1000, 2500]
                },
            }
        ]
    },
    'big-box-12': {
        'combination': [
            {
                0: {
                    name: "MiniCard",
                    subtitle: "12 Stuks (2 x 6)",
                    type: ["Melk", "Puur", "Wit", "Mix"],
                    weight: ["10gr"],
                    packaging: ["in een geschenkdoos", "in een geschenkdoos met gepersonaliseerde huls", "in een gepersonaliseerde geschenkdoos"],
                    amounts: [80, 120, 250, 500, 1000, 1500]
                },
                1: {
                    name: "Praline",
                    subtitle: "6 Stuks",
                    type: ["Melk", "Puur", "Wit", "Mix"],
                    weight: ["15gr"],
                    packaging: ["in een geschenkdoos", "in een geschenkdoos met gepersonaliseerde huls", "in een gepersonaliseerde geschenkdoos"],
                    amounts: [80, 120, 250, 500, 1000, 1500]
                }
            },
            {
                0: {
                    name: "MiniCard",
                    subtitle: "12 Stuks (2 x 6)",
                    type: ["Melk", "Puur", "Wit", "Mix"],
                    weight: ["10gr"],
                    packaging: ["in een geschenkdoos", "in een geschenkdoos met gepersonaliseerde huls", "in een gepersonaliseerde geschenkdoos"],
                    amounts: [80, 120, 250, 500, 1000, 1500]
                },
                1: {
                    name: "Praline",
                    subtitle: "6 Stuks",
                    type: ["Melk", "Puur", "Wit", "Mix"],
                    weight: ["15gr"],
                    packaging: ["in een geschenkdoos", "in een geschenkdoos met gepersonaliseerde huls", "in een gepersonaliseerde geschenkdoos"],
                    amounts: [80, 120, 250, 500, 1000, 1500]
                }
            }
        ]
    },
    'big-box-maxi-6': {
        'combination': [
            {
                0: {
                    name: "Postcard",
                    subtitle: "",
                    type: ["Melk", "Puur", "Wit"],
                    weight: ["100gr"],
                    packaging: ["in een geschenkdoos", "in een geschenkdoos met gepersonaliseerde huls", "in een gepersonaliseerde geschenkdoos"],
                    amounts: [80, 120, 250, 500, 1000, 1500]
                },
                1: {
                    name: "ChristmasCard",
                    subtitle: "",
                    type: ["Wit"],
                    weight: ["100gr"],
                    packaging: ["in een geschenkdoos", "in een geschenkdoos met gepersonaliseerde huls", "in een gepersonaliseerde geschenkdoos"],
                    amounts: [80, 120, 250, 500, 1000, 1500]
                },
                2: {
                    name: "EasterCard",
                    subtitle: "",
                    type: ["Wit"],
                    weight: ["100gr"],
                    packaging: ["in een geschenkdoos", "in een geschenkdoos met gepersonaliseerde huls", "in een gepersonaliseerde geschenkdoos"],
                    amounts: [80, 120, 250, 500, 1000, 1500]
                },
                3: {
                    name: "MedaillionCard",
                    subtitle: "",
                    type: ["Wit"],
                    weight: ["100gr"],
                    packaging: ["in een geschenkdoos", "in een geschenkdoos met gepersonaliseerde huls", "in een gepersonaliseerde geschenkdoos"],
                    amounts: [80, 120, 250, 500, 1000, 1500]
                },
            },
            {
                0: {
                    name: "MiniCard",
                    subtitle: "12 Stuks (2 x 6)",
                    type: ["Melk", "Puur", "Wit", "Mix"],
                    weight: ["10gr"],
                    packaging: ["in een geschenkdoos", "in een geschenkdoos met gepersonaliseerde huls", "in een gepersonaliseerde geschenkdoos"],
                    amounts: [80, 120, 250, 500, 1000, 1500]
                },
                1: {
                    name: "Praline",
                    subtitle: "6 Stuks",
                    type: ["Melk", "Puur", "Wit", "Mix"],
                    weight: ["15gr"],
                    packaging: ["in een geschenkdoos", "in een geschenkdoos met gepersonaliseerde huls", "in een gepersonaliseerde geschenkdoos"],
                    amounts: [80, 120, 250, 500, 1000, 1500]
                }
            }
        ]
    },
    'big-box-maxi-double': {
        'combination': [
            {
                0: {
                    name: "Postcard",
                    subtitle: "",
                    type: ["Melk", "Puur", "Wit"],
                    weight: ["100gr"],
                    packaging: ["in een geschenkdoos", "in een geschenkdoos met gepersonaliseerde huls", "in een gepersonaliseerde geschenkdoos"],
                    amounts: [80, 120, 250, 500, 1000, 1500]
                },
                1: {
                    name: "ChristmasCard",
                    subtitle: "",
                    type: ["Wit"],
                    weight: ["100gr"],
                    packaging: ["in een geschenkdoos", "in een geschenkdoos met gepersonaliseerde huls", "in een gepersonaliseerde geschenkdoos"],
                    amounts: [80, 120, 250, 500, 1000, 1500]
                },
                2: {
                    name: "EasterCard",
                    subtitle: "",
                    type: ["Wit"],
                    weight: ["100gr"],
                    packaging: ["in een geschenkdoos", "in een geschenkdoos met gepersonaliseerde huls", "in een gepersonaliseerde geschenkdoos"],
                    amounts: [80, 120, 250, 500, 1000, 1500]
                },
                3: {
                    name: "MedaillionCard",
                    subtitle: "",
                    type: ["Wit"],
                    weight: ["100gr"],
                    packaging: ["in een geschenkdoos", "in een geschenkdoos met gepersonaliseerde huls", "in een gepersonaliseerde geschenkdoos"],
                    amounts: [80, 120, 250, 500, 1000, 1500]
                },
            },
            {
                0: {
                    name: "Postcard",
                    subtitle: "",
                    type: ["Melk", "Puur", "Wit"],
                    weight: ["100gr"],
                    packaging: ["in een geschenkdoos", "in een geschenkdoos met gepersonaliseerde huls", "in een gepersonaliseerde geschenkdoos"],
                    amounts: [80, 120, 250, 500, 1000, 1500]
                },
                1: {
                    name: "ChristmasCard",
                    subtitle: "",
                    type: ["Wit"],
                    weight: ["100gr"],
                    packaging: ["in een geschenkdoos", "in een geschenkdoos met gepersonaliseerde huls", "in een gepersonaliseerde geschenkdoos"],
                    amounts: [80, 120, 250, 500, 1000, 1500]
                },
                2: {
                    name: "EasterCard",
                    subtitle: "",
                    type: ["Wit"],
                    weight: ["100gr"],
                    packaging: ["in een geschenkdoos", "in een geschenkdoos met gepersonaliseerde huls", "in een gepersonaliseerde geschenkdoos"],
                    amounts: [80, 120, 250, 500, 1000, 1500]
                },
                3: {
                    name: "MedaillionCard",
                    subtitle: "",
                    type: ["Wit"],
                    weight: ["100gr"],
                    packaging: ["in een geschenkdoos", "in een geschenkdoos met gepersonaliseerde huls", "in een gepersonaliseerde geschenkdoos"],
                    amounts: [80, 120, 250, 500, 1000, 1500]
                },
            }
        ]
    }
}


// WEBPACK FOOTER //
// ./resources/js/offer-form-options.js